import { FC, useRef, useState, MouseEvent } from 'react'
import { IconButton } from '@material-tailwind/react'
import { PiPlayCircleLight, PiStopCircleFill } from 'react-icons/pi'

interface PlayerMiniProps {
  audioUrl: string
}

const PlayerMini: FC<PlayerMiniProps> = ({ audioUrl }) => {
  const audioRef = useRef<HTMLAudioElement>(null)
  const [canPlay, setCanPlay] = useState(false)
  const [isPlaying, setIsPlaying] = useState(false)

  const startAudio = (audioEl: HTMLAudioElement) => {
    if (!audioEl) return
    // eslint-disable-next-line
    audioEl.currentTime = 0
    audioEl.play()
    setIsPlaying(true)
  }

  const stopAudio = (audioEl: HTMLAudioElement) => {
    if (!audioEl) return
    audioEl.pause()
    // eslint-disable-next-line
    audioEl.currentTime = 0
    setIsPlaying(false)
  }

  const togglePlay = (e: MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    if (!canPlay || !audioRef.current) return
    if (audioRef.current.paused) {
      startAudio(audioRef.current)
    } else {
      stopAudio(audioRef.current)
    }
  }

  return (
    <div className="w-full flex items-center">
      <IconButton variant="text" className="text-primary dark:text-base-gray-500" onClick={togglePlay}>
        {isPlaying ? <PiStopCircleFill className="h-6 w-6" /> : <PiPlayCircleLight className="h-6 w-6" />}
      </IconButton>
      <audio
        ref={audioRef}
        className="hidden"
        src={audioUrl}
        onCanPlay={() => setCanPlay(true)}
        aria-label="Audio player"
      />
    </div>
  )
}

export default PlayerMini
